import data from './data'
import methods from './methods'
import components from './components'

export default {
  data,
  methods,
  components,

  resourcePath: 'v1/professional/agendas/agendas/'
}



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/gadget/components/active-agenda/resources/index.js